<!-- Add a container wrapper -->
<div class="page-container">
  <app-header></app-header>
  <div class="content">
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <title>FuProp Info Card</title>
        <style>
    body {
  font-family: "Nunito", sans-serif;
      background-color: #f4f6f8;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 80vh;
      margin: 0;
    }

    .card {
      background-color: #ffffff;
      max-width: 800px;
      padding: 30px;
      border-radius: 16px;
      box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
    }

    .card h2 {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #333;
    }

    .card h3 {
      font-size: 22px;
      font-weight: bold;
      margin-top: 25px;
      margin-bottom: 10px;
      color: #444;
    }

    .card p {
      font-size: 16px;
      line-height: 1.6;
      color: #555;
      margin-bottom: 10px;
    }
  </style>
      </head>
      <body>

        <div class="card">
          <h2>Welcome to FuProp!</h2>
          <p>
            At FuProp, our mission is to provide innovative, user-centered
            solutions that empower individuals and businesses
            to achieve their goals seamlessly and efficiently. We are a team of
            dedicated professionals who believe in
            harnessing technology to deliver high-quality, reliable services
            that make a real difference.
          </p>

          <h3>Our Vision</h3>
          <p>
            To create a platform that simplifies complex tasks, enhances
            productivity, and fosters meaningful connections.
            At G3G, we strive to be more than a service provider – we want to be
            a partner in your success.
          </p>

          <h3>Why Choose FuProp?</h3>
          <p>
            FuProp was founded with a simple yet powerful goal: to make
            technology more accessible and beneficial for
            everyone. Our team brings expertise from diverse fields, working
            together to develop solutions that are both
            efficient and effective.
          </p>
          <p>
            Whether you’re an individual seeking to streamline tasks or a
            business looking to scale, FuProp offers the tools
            and support to help you succeed.
          </p>
          <p>
            Thank you for choosing FuProp. We’re excited to be part of your
            journey and look forward to serving you!
          </p>
        </div>

      </body>
    </html>

    <app-footer></app-footer>
  </div>
